<template>
  <div
    class="sk-chase"
    role="status"
  >
    <div
      class="sk-chase-dot"
      aria-hidden="true"
    />
    <div
      class="sk-chase-dot"
      aria-hidden="true"
    />
    <div
      class="sk-chase-dot"
      aria-hidden="true"
    />
    <div
      class="sk-chase-dot"
      aria-hidden="true"
    />
    <div
      class="sk-chase-dot"
      aria-hidden="true"
    />
    <div
      class="sk-chase-dot"
      aria-hidden="true"
    />
    <span class="visually-hidden">{{ label }}</span>
  </div>
</template>

<script>
export default {
    name: 'UncLoader',
    props: {
        label: {
            type: String,
            default: 'Cargando',
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
